import * as actionTypes from "./UserAuthenticationActionTypes";

export const logoutUserAction = () => (dispatch: any) => {
  dispatch({ type: actionTypes.LOGOUT_USER });
};